// src/components/HowItWorks.jsx
export default function HowItWorks() {
  const steps = [
    {
      src: "/images/Purchase Securely.png",
      title: "Purchase Securely",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    {
      src: "/images/Ships From Warehouse.png",
      title: "Ships From Warehouse",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    {
      src: "/images/Style Your Room.png",
      title: "Style Your Room",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
  ];

  return (
    <section id="how-it-works" className="bg-white">
      <div
        className="mx-auto max-w-6xl px-6 py-12"
        style={{ fontFamily: "Montserrat, ui-sans-serif, system-ui" }}
      >
        <h2 className="text-center text-2xl md:text-3xl font-extrabold text-gray-900">
          How It Works
        </h2>
        <p className="text-center text-gray-500 mt-2">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map(({ src, title, text }) => (
            <article key={title} className="flex flex-col items-center text-center">
              {/* Imagen con números ya integrados */}
              <div className="w-full overflow-hidden rounded-[12px] shadow-sm">
                <img
                  src={src}
                  alt={title}
                  loading="lazy"
                  className="w-full h-[clamp(200px,28vw,288px)] object-cover"
                />
              </div>

              <h3 className="mt-4 text-gray-900 font-semibold">{title}</h3>
              <p className="mt-1 text-gray-500 text-sm max-w-[320px]">
                {text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
